import { render, staticRenderFns } from "./DashBoardSettingsUserView.vue?vue&type=template&id=fa295ad2&scoped=true&"
import script from "./DashBoardSettingsUserView.vue?vue&type=script&lang=js&"
export * from "./DashBoardSettingsUserView.vue?vue&type=script&lang=js&"
import style0 from "./DashBoardSettingsUserView.vue?vue&type=style&index=0&id=fa295ad2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa295ad2",
  null
  
)

export default component.exports